import { HttpErrorResponse } from '@angular/common/http';

/**
 * Reads the ProblemDetails `title` from anything a KT API call can reject with.
 *
 * Mirrors `httpErrorStatus`: the generated hey-api client throws the ProblemDetails **body** itself,
 * `HttpClient` wraps it in an `HttpErrorResponse`, and Angular's `resource()` wraps a non-Error
 * rejection in an `Error` whose `cause` holds the original — inspected exactly once, never deeper.
 *
 * @param error The rejection to inspect.
 * @returns The ProblemDetails title, or `undefined` when none can be read.
 */
export function httpErrorTitle(error: unknown): string | undefined {
  const title = ownTitle(error);
  if (title !== undefined) {
    return title;
  }

  return error instanceof Error ? ownTitle(error.cause) : undefined;
}

/**
 * Reads the title carried directly by an `HttpErrorResponse` body or a `{ title: string }` object.
 *
 * @param error The value to inspect.
 * @returns The title, or `undefined` when the value carries none.
 */
function ownTitle(error: unknown): string | undefined {
  const body: unknown = error instanceof HttpErrorResponse ? (error.error as unknown) : error;

  if (typeof body === 'object' && body !== null && 'title' in body) {
    const { title } = body;
    return typeof title === 'string' ? title : undefined;
  }

  return undefined;
}
